module.exports = new __parcel__URL__("10380037.f6a2d154.png").toString();